import SkiLift from "../../images/sunkIcon/1-Ski-lift.png";
import Netflix from "../../images/sunkIcon/2-Netflix.png";
import Swift from "../../images/sunkIcon/3-Swift.png";
import Instapot from "../../images/sunkIcon/4-Instapot.png";
import Jeans from "../../images/sunkIcon/5-Jeans.png";
import btChickenicoin from "../../images/sunkIcon/6-Chicken.png";
import Pickleball from "../../images/sunkIcon/7-Pickleball.png";
import Car from "../../images/sunkIcon/8-Car.png";
import FerrisWheel from "../../images/sunkIcon/9-Ferriswheel.png";
import Ticket from "../../images/sunkIcon/10-Ticket.png";

const questions = [
  {
    id: 1,
    title: "Ski Ticket",
    desc: "You bought a non-refundable $100 ski lift ticket. But after hitting the slopes for an hour, you’re freezing cold.",
    boldText: "You're deciding whether to go home. Is the ticket a sunk cost?",
    answer: "yes", //sunkCost
    icon: SkiLift,
    wrongAnswerText:
      "Not quite! The cost of the lift ticket can't be recovered, so it's a sunk cost.",
    rightAnswerText:
      "Great job! Since you can't get your money back, it's a sunk cost. It should not enter into your decision to stay.",
  },
  {
    id: 2,
    title: "Netflix",
    boldText: "It is the sixth day and you're deciding whether to continue after the 7 day trial ends. Is the $15/month a sunk cost?",
    desc: "You signed up for a 7 day free Netflix trial, but your card will be charged $15/month after that.",
    answer: "no", //not sunkCost
    icon: Netflix,
    wrongAnswerText:
      "Not quite! Since you haven't spent the $15 yet, it's not a sunk cost.",
    rightAnswerText:
      "Great job! Since you haven't spent the $15 yet, it's not a sunk cost.",
  },
  {
    id: 3,
    title: "Taylor Swift",
    boldText: "You're deciding whether to purchase real tickets. Are the fake tickets a sunk cost?",
    desc: "You purchased $500 Taylor Swift tickets from someone on Facebook marketplace, but it turns out the tickets were fake.",
    answer: "yes",
    icon: Swift,
    wrongAnswerText: "Not quite! Since you can't get your money back for the fake tickets, it's a sunk cost.",
    rightAnswerText: "Great job! Since you can't get your money back, it's a sunk cost.",
  },
  {
    id: 4,
    title: "Instant Pot",
    boldText: "You're deciding whether to throw it out. Is the $150 spent on the pot a sunk cost?",
    desc: "During the pandemic you bought a $150 Instant Pot, but now it’s sitting unused in your closet.",
    answer: "yes",
    icon: Instapot,
    wrongAnswerText: "Not quite! Since you can't return your Instant Pot and get your money back, it's a sunk cost.",
    rightAnswerText: "Great job! Since you can't get your money back, it's a sunk cost. The only thing that matters going forward is whether you value the free space in your home over the Instant Pot.",
  },
  {
    id: 5,
    title: "Jeans",
    desc: "You bought $75 jeans from a website with free return shipping. After trying them on at home, you decide they aren’t so great after all.",
    boldText: "You're deciding whether to return the jeans. Was the $75 you paid for them a sunk cost?",
    answer: "no",
    icon: Jeans,
    wrongAnswerText:
      "Not quite! Since you can return the jeans for a full refund, your $75 isn't a sunk cost (yet).",
    rightAnswerText:
      "Great job! Since you can return the jeans and get your money back, the $75 isn't a sunk cost (yet).",
  },
  {
    id: 6,
    title: "Chicken",
    desc: "You brought home free leftovers from work for dinner. Then, you remember the chicken you bought last week is set to expire tomorrow.",
    boldText: "You're deciding what to eat for dinner. Is the price of the chicken a sunk cost?",
    answer: "yes",
    icon: btChickenicoin,
    wrongAnswerText:
      "Not quite! Since you can't return the chicken and get your money back, it's a sunk cost.",
    rightAnswerText:
      "Great job! Since you can't return the chicken and get your money back, it's a sunk cost. You should base your dinner decision on what you would prefer.",
  },
  {
    id: 7,
    title: "Pickleball (Part 1)",
    desc: "You paid $100 to join a pickleball league last month, but today’s game is an hour drive from your home.",
    boldText: "You're deciding whether to go. Is the <i>$100 membership fee</i> a sunk cost?",
    answer: "yes",
    icon: Pickleball,
    wrongAnswerText:
      "Not quite! Since you already paid the membership fee, it's a sunk cost.",
    rightAnswerText:
      "Great job! Since you already paid the membership fee, it's a sunk cost. It should not enter into your decision to go to the game.",
  },
  {
    id: 8,
    title: "Pickleball (Part 2)",
    desc: "You paid $100 to join a pickleball league last month, but today’s game is an hour drive from your home.",
    boldText: "You're deciding whether to go. Is the <i>one hour car ride</i> a sunk cost?",
    answer: "no",
    icon: Car,
    wrongAnswerText:
      "Not quite! Since you haven't driven yet, you can still decide how to use your time.",
    rightAnswerText:
      "Great job! The drive is not a sunk cost. You can decide whether the cost of the drive is worth the enjoyment of the game.",
  },
  {
    id: 9,
    title: "State Fair (Part 1)",
    desc: "You bought a $20 ticket to the State Fair. Once inside, you want to ride the ferris wheel—but the line is an hour long.",
    boldText: "You're deciding whether to ride the ferris wheel. Is the <i>value of your time</i> a sunk cost?",
    answer: "no",
    icon: FerrisWheel,
    wrongAnswerText:
      "Not quite! Since you haven't spent your time yet, it's not a sunk cost.",
    rightAnswerText:
      "Great job! Since you haven't waited an hour in line yet, you can still decide how to use your time at the fair.",
  },
  {
    id: 10,
    title: "State Fair (Part 2)",
    desc: "You bought a $20 ticket to the State Fair. Once inside, you want to ride the ferris wheel—but the line is an hour long.",
    boldText: "You're deciding whether to ride the ferris wheel. Is the <i>$20 ticket</i> a sunk cost?",
    answer: "yes",
    icon: Ticket,
    wrongAnswerText:
      "Not quite! Since you already spent the $20, it's a sunk cost.",
    rightAnswerText:
      "Great job! Since you already spent the $20, it's a sunk cost.",
  },
];

export default questions;
